function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M40 8v24a8 8 0 01-8 8h-5.78V24.89h6.67v-6.67h-6.67v-2.65c0-1.08.69-1.79 1.28-1.79h5.39V7.11H27.5c-4.14 0-7.5 4-7.5 8.51v2.6h-4.89v6.67H20V40H8a8 8 0 01-8-8V8a8 8 0 018-8h24a8 8 0 018 8z"
});

function SvgIconFacebookSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJtNDAgOHYyNGMwIDQuNDE4Mjc4LTMuNTgxNzIyIDgtOCA4aC01Ljc4di0xNS4xMWg2LjY3di02LjY3aC02LjY3di0yLjY1YzAtMS4wOC42OS0xLjc5IDEuMjgtMS43OWg1LjM5di02LjY3aC01LjM5Yy00LjE0IDAtNy41IDQtNy41IDguNTF2Mi42aC00Ljg5djYuNjdoNC44OXYxNS4xMWgtMTJjLTQuNDE4Mjc4IDAtOC0zLjU4MTcyMi04LTh2LTI0YzAtNC40MTgyNzggMy41ODE3MjItOCA4LThoMjRjNC40MTgyNzggMCA4IDMuNTgxNzIyIDggOHoiLz48L3N2Zz4K";
export { SvgIconFacebookSquare as ReactComponent };